<template>
  <tr>
    <th rowspan="2" class="kpi-performance-table__metrics kpi-performance-table__endColGroup">{{ title }}</th>
    <th colspan="5" class="kpi-performance-table__endColGroup kpi-performance-table__big-header kpi-performance-table__halfHeader">Current Month {{ monthYearString }}</th>
    <th colspan="5" class="kpi-performance-table__endColGroup kpi-performance-table__big-header kpi-performance-table__halfHeader">Year to Date {{ monthYearString }}</th>
    <th rowspan="2" class="kpi-performance-table__comments">Commentary</th>
  </tr>
</template>

<script>
  export default {
    name: 'TableHead',
    props: ['title', 'monthYearString'],
  };
</script>
